import { render, staticRenderFns } from "./headlines-exinfo.vue?vue&type=template&id=6bcb25b2&scoped=true&"
import script from "./headlines-exinfo.vue?vue&type=script&lang=js&"
export * from "./headlines-exinfo.vue?vue&type=script&lang=js&"
import style0 from "./headlines-exinfo.vue?vue&type=style&index=0&id=6bcb25b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb25b2",
  null
  
)

export default component.exports